import { AfterViewInit, Component, EventEmitter, Input, Output } from '@angular/core';
import { FilterService } from '@progress/kendo-angular-grid';
import { distinct, filterBy } from '@progress/kendo-data-query';
import { commonService } from 'src/app/services/common.service';

interface CompositeFilterDescriptor {
  logic: 'or' | 'and';
  filters: Array<any>;
}

@Component({
  selector: 'app-custom-grid-filter',
  templateUrl: './custom-grid-filter.component.html',
  styleUrl: './custom-grid-filter.component.scss'
})
export class CustomGridFilterComponent implements AfterViewInit {

  filterType: string = "condition";
  @Input() set setFilterType(filterType: string) {
    if (filterType) {
      this.filterType = filterType;
    }
  }

  @Output() filterTypeChanged = new EventEmitter<string>();
  @Output() actionClicked = new EventEmitter<string>();
  @Output() lastfilteredValue = new EventEmitter<string>();

  filterDataType: string = "string";
  @Input() set setFilterDataType(filterDataType: string) {
    this.filterDataType = filterDataType;
  }

  valueFilterText: string = "string";
  @Input() set setvalueFilterText(valueFilterText: string) {
    this.valueFilterText = valueFilterText;
  }

  @Input() public isPrimitive: boolean = false;
  conditionFilter!: CompositeFilterDescriptor;
  valueFilter!: CompositeFilterDescriptor;
  ogConditionFilter!: CompositeFilterDescriptor;
  ogValueFilter!: CompositeFilterDescriptor;
  filter!: CompositeFilterDescriptor;
  gridFilter!: CompositeFilterDescriptor;

  defaultFilter: CompositeFilterDescriptor = {
    filters: [],
    logic: 'or'
  };

  @Input() public set setGridFilter(filter: any) {
    this.gridFilter = filter;
  }

  @Input() public set setFilter(filter: any) {
    this.filter = filter;
  }

  @Input() public set setCurrentValueFilter(currentFilter: any) {
    if (currentFilter != undefined) {
      if (currentFilter.filters?.length != this.valueFilter?.filters?.length || currentFilter?.logic != this.valueFilter?.logic) {
        let filter = this.defaultFilter;
        if (currentFilter) {
          filter = currentFilter;
        }

        this.valueFilter = this.commonService.deepClone(filter);
        // this.value = this.column.valueFilter.filters.map((x: any) => x.value);

        const filtered: any[] = [];
        let count = 0;
        for (let i = 0; i < this.column.valueFilter.filters.length && count < 250; i++) {
          filtered.push(this.column.valueFilter.filters[i].value);
          count++;
        }
        this.value = filtered;

      }
    }
  }

  @Input() public set setCurrentConditionFilter(currentFilter: any) {
    if (currentFilter.filters.length != this.valueFilter?.filters?.length || currentFilter.logic != this.valueFilter?.logic) {
      let filter = this.defaultFilter;
      if (currentFilter) {
        filter = currentFilter;
      }

      this.conditionFilter = this.commonService.deepClone(filter);
    }
  }

  data: any[] = [];
  @Input() public set setListData(data: any[]) {
    this.data = data;
  }

  @Input() public textField: any;
  @Input() public valueField: any;

  conditionFilterService: FilterService = new FilterService;
  valueFilterService: FilterService = new FilterService;
  filterService: FilterService = new FilterService;

  @Input() public set setFilterService(filterService: FilterService) {
    this.filterService = filterService;
    this.valueFilterService = filterService;
    this.conditionFilterService = filterService;
  }

  @Input() public field: string = "";
  @Input() public column: any;
  @Output() public clearFilter = new EventEmitter<any>();
  allSelected = true;

  public currentData: any[] = [];
  public value: unknown[] = [];

  public textAccessor(dataItem: any): any {
    return this.isPrimitive ? dataItem : dataItem[this.textField];
  }

  public valueAccessor(dataItem: any): any {
    return this.isPrimitive ? dataItem : dataItem[this.valueField];
  }

  constructor(private commonService: commonService) {

  }

  public ngAfterViewInit(): void {
    if (this.valueFilterText) {
      // this.currentData = this.data?.filter((x: any) => x.toString().toLocaleLowerCase().includes(this.valueFilterText.toLocaleLowerCase())) || [];

      const searchValue = this.valueFilterText.toLocaleLowerCase();
      const filtered: any[] = [];
      let count = 0;
      for (let i = 0; i < this.data.length && count < 250; i++) {
        const itemStr = this.data[i]?.toString()?.toLocaleLowerCase();
        if (itemStr && itemStr.includes(searchValue)) {
          filtered.push(this.data[i]);
          count++;
        }
      }
      this.currentData = filtered;
    } else {
      this.currentData = this.data.slice(0, 250) || [];
    }

    if (!this.column.valueFilter || !this.column.valueFilter?.filters?.length) {
      if (this.currentData.length > 0) {
        this.allSelected = true;
        this.toggleSelectAll();
      }
    }
    console.log(this.currentData.length)

    this.ogValueFilter = this.commonService.deepClone(this.valueFilter);
    this.ogValueFilter = this.commonService.deepClone(this.ogValueFilter);
  }
  public trackByItem(index: number, item: any): any {
    return this.isPrimitive ? item : item[this.valueField];
  }
  public toggleSelectAll(): void {
    this.value = this.allSelected ? this.data : [];

    let filters = this.value.map(value => ({
      field: this.field,
      operator: 'eq',
      value
    }));

    this.valueFilterService.filter({
      filters: filters,
      logic: 'or'
    });

    this.column.valueFilter = this.commonService.deepClone({
      filters: filters,
      logic: 'or'
    });
  }

  public isItemSelected(item: unknown): boolean {
    let result = false;
    // if (this.filterDataType == 'date') {
    //   result = this.value.some((x: any) => x?.getTime() === this.valueAccessor(item)?.getTime());
    // } else 
    {
      result = this.value.some(x => x === this.valueAccessor(item));
    }
    return result;
    // let result = false;
    // if (this.filterDataType == 'date') {
    //   result = this.value.some((x: any) => x?.getTime() === this.valueAccessor(item)?.getTime());
    // } else {
    //   result = this.value.some(x => x === this.valueAccessor(item));
    // }
    // return result;
  }

  public onSelectionChange(item: unknown, li: HTMLLIElement): void {
    if (this.value.length > 250) {
      this.value = this.value.slice(0, 250);
    }
    if (this.value.some(x => x === item)) {
      this.value = this.value.filter(x => x !== item);
    } else {
      this.value.push(item);
    }

    this.updateSelectAllState(); // ✅ keep Select All in sync

    let filters = this.value.map(value => ({
      field: this.field,
      operator: 'eq',
      value
    }));

    this.valueFilterService.filter({
      filters: filters,
      logic: 'or'
    });

    this.column.valueFilter = this.commonService.deepClone({
      filters: filters,
      logic: 'or'
    });

    this.onFocus(li);
  }

  public onInput(e: any): void {
    let data = this.data;
    if (e.target.value) {
      if (this.filterDataType != "string") {
        // this.currentData = data.filter((x: any) => x.toString().toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase()));

        // Use a for loop for better performance with large arrays
        const searchValue = e.target.value.toLocaleLowerCase();
        const filtered: any[] = [];
        let count = 0;
        for (let i = 0; i < data.length && count < 250; i++) {
          const itemStr = data[i]?.toString()?.toLocaleLowerCase();
          if (itemStr && itemStr.includes(searchValue)) {
            filtered.push(data[i]);
            count++;
          }

        }
        this.currentData = filtered;

      } else {
        // this.currentData = data.filter((x: any) => x.toLocaleLowerCase().includes(e.target.value.toLocaleLowerCase()));
        const searchValue = e.target.value.toLocaleLowerCase();
        const filtered: any[] = [];
        let count = 0;
        for (let i = 0; i < data.length && count < 250; i++) {
          const itemStr = data[i]?.toLocaleLowerCase();
          if (itemStr && itemStr.includes(searchValue)) {
            filtered.push(data[i]);
            count++;
          }

        }
        this.currentData = filtered;
      }
    } else {
      this.currentData = this.data?.slice(0, 250) || [];
    }

    this.value = this.currentData;
    this.column.valueFilterText = e.target.value;

    let filters = this.value.map(value => ({
      field: this.field,
      operator: 'eq',
      value
    }));

    this.column.valueFilter = this.commonService.deepClone({
      filters: filters,
      logic: 'or'
    });

    this.valueFilterService.filter({
      filters: filters,
      logic: 'or'
    });

    this.updateSelectAllState();
  }


  public onFocus(li: HTMLLIElement): void {
    const ul = li.parentNode as HTMLUListElement;
    const below = ul.scrollTop + ul.offsetHeight < li.offsetTop + li.offsetHeight;
    const above = li.offsetTop < ul.scrollTop;

    // Scroll to focused checkbox
    if (above) {
      ul.scrollTop = li.offsetTop;
    }

    if (below) {
      ul.scrollTop += li.offsetHeight;
    }
  }

  filterTypeChange(type: string) {
    this.filterType = type;
    if (type == 'condition') {
      if (this.conditionFilterService == undefined) {
        this.conditionFilterService = new FilterService();
        this.conditionFilterService.filter({
          filters: [],
          logic: 'or'
        });
      }

      if (this.conditionFilter == undefined) {
        this.conditionFilter = {
          filters: [],
          logic: 'or'
        };
      }
    }

    this.column.filterType = this.filterType;
  }
  
  onConditionFilterChange() {   
    if (this.data.length > 250 && this.value.length === 250 && this.filterType == 'value') {
      return this.resetFilters();
    }

    this.column.filterType = this.filterType;

    let rawFilter = this.filterType === 'condition' ? this.conditionFilter : this.valueFilter;

    // Clean up filters before cloning
    rawFilter.filters = rawFilter.filters.filter(x => x?.value);

    // Clone after cleanup
    const clonedFilter = this.commonService.deepClone(rawFilter);

    // Assign to column
    if (this.filterType === 'condition') {
      this.column.conditionFilter = clonedFilter;
    } else {
      this.column.valueFilter = clonedFilter;    }

    this.filter = clonedFilter;
    this.filterService.filter(this.filter);
    
    this.filterTypeChanged.emit(this.filterType);
    this.actionClicked.emit('filter');
    this.lastfilteredValue.emit(this.textField);
  }


  resetFilters() {
    this.column.filterType = this.filterType;
    this.column.valueFilterText = '';
    if (this.filterType == 'condition') {
      this.column.conditionFilter = this.commonService.deepClone(this.defaultFilter);
    } else {
      this.column.valueFilter = this.commonService.deepClone(this.defaultFilter);
    }

    this.filter = this.commonService.deepClone(this.defaultFilter);

    let selectedColumnIndex = this.gridFilter?.filters?.findIndex((x: any) => x.filters.some((y: any) => y.field == this.field));

    if (selectedColumnIndex > -1) {
      this.gridFilter.filters.splice(selectedColumnIndex, 1);

      this.filterService.filter(this.filter);
    }
    this.clearFilter.emit(this.gridFilter);
    this.allSelected = false;
    this.actionClicked.emit('reset');
  }

  cancelFilter() {
    if (this.filterType == 'condition') {
      this.column.conditionFilter = this.ogConditionFilter;
    } else {
      this.column.valueFilter = this.ogValueFilter;
      this.value = this.column?.valueFilter?.filters.map((x: any) => x.value) ?? [];
    }

    this.actionClicked.emit('cancel');

    this.filterService.filter(this.filterType == 'condition' ? this.ogConditionFilter : this.ogValueFilter);
  }

  deepClone(obj: any): any {
    // Check if the value is an object or a Date instance
    if (obj === null || typeof obj !== 'object') {
      return obj;
    }

    if (obj instanceof Date) {
      return new Date(obj.getTime()); // Clone Date instance
    }

    // Handle arrays
    if (Array.isArray(obj)) {
      return obj.map(item => this.deepClone(item));
    }

    // Handle objects
    const clonedObj: any = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        clonedObj[key] = this.deepClone(obj[key]);
      }
    }

    return clonedObj;
  }

  private updateSelectAllState(): void {
    const selectedValues = this.value.map(v => v);
    const allVisibleValues = this.currentData.map(item => this.valueAccessor(item));
    this.allSelected = allVisibleValues.every(val => selectedValues.includes(val));
  }
}
